<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import SidenavItem from "./SidenavItem.vue";

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

// Controlar el estado de los desplegables
const showTime = ref(false);
const showAccountSettings = ref(false);
const showAdmin = ref(false);
const showReports = ref(false);
const showProjects = ref(false);

let isSA = ref(false)
let isAdmin = ref(false)
let isEmployee = ref(false)
let isNominist = ref(false)
let isPM = ref(false)
let isExternal = ref(false)

//Obtener info del token
import { jwtDecode } from "jwt-decode";
const token = localStorage.getItem("authToken");
if (token) {
  try {
    const decodedToken = jwtDecode(token);
    if (decodedToken.user_type_id == 1) {
      isSA.value = true
      isAdmin.value = true
      isNominist.value = true
      isEmployee.value = true
    }

    if (decodedToken.user_type_id == 2) {
      isAdmin.value = true
      isNominist.value = true
      isEmployee.value = true
    }

    if (decodedToken.user_type_id == 4) {
      isNominist.value = true
      isEmployee.value = true
    }

    if (decodedToken.user_type_id == 3) {
      isEmployee.value = true
    }

    if (decodedToken.is_pm === true) {
      isPM.value = true
    }

    if (decodedToken.user_type_id === 7) {
      isExternal.value = true
    }

  } catch (error) {
    console.error("Error al decodificar el token:", error);
  }
} else {
  console.log("No hay token en localStorage");
}
</script>

<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item" v-if="!isExternal">
        <sidenav-item to="/home" :class="getRoute() === 'home' ? 'active' : ''" :navText="'Inicio'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- HORAS - Desplegable -->
      <li class="nav-item" v-if="!isExternal">
        <div @click="showTime = !showTime" class="nav-link cursor-pointer">
          <i class="ni ni-time-alarm text-warning text-sm opacity-10"></i>
          <span class="ms-2">Registrar Tiempo</span>
          <i class="ms-auto" :class="showTime ? 'ni ni-bold-up' : 'ni ni-bold-down'"></i>
        </div>
        <ul v-show="showTime" class="list-unstyled ms-4">
          <sidenav-item to="/calendar" :class="getRoute() === 'calendar' ? 'active' : ''" :navText="'Registrar Agenda'">
            <template v-slot:icon>
              <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
        <ul v-show="showTime" class="list-unstyled ms-4">
          <sidenav-item to="/hours" :class="getRoute() === 'hours' ? 'active' : ''" :navText="'Registrar Horas'">
            <template v-slot:icon>
              <i class="ni ni-time-alarm text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
      </li>

      <!-- MIS PROYECTOS - Desplegable (Visible para PMS) -->
      <li class="nav-item" v-if="isPM || isExternal">
        <div @click="showProjects = !showProjects" class="nav-link cursor-pointer">
          <i class="ni ni-app text-warning text-sm opacity-10"></i>
          <span class="ms-2">Mis Proyectos</span>
          <i class="ms-auto" :class="showReports ? 'ni ni-bold-up' : 'ni ni-bold-down'"></i>
        </div>
        <ul v-if="isPM && !isExternal" v-show="showProjects" class="list-unstyled ms-4">
          <sidenav-item to="/my-projects" :class="getRoute() === 'my-projects' ? 'active' : ''"
            :navText="'Mis Proyectos'">
            <template v-slot:icon>
              <i class="ni ni-app text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
        <ul v-if="isPM && !isExternal" v-show="showProjects" class="list-unstyled ms-4">
          <sidenav-item to="/auth-project-hours" :class="getRoute() === 'auth-project-hours' ? 'active' : ''"
            :navText="'Aut. Horas Proyectos'">
            <template v-slot:icon>
              <i class="ni ni-time-alarm text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
      </li>

      <!-- REPORTES - Desplegable -->
      <li class="nav-item" v-if="isAdmin || isNominist">
        <div @click="showReports = !showReports" class="nav-link cursor-pointer">
          <i class="ni ni-chart-bar-32 text-warning text-sm opacity-10"></i>
          <span class="ms-2">Reportes</span>
          <i class="ms-auto" :class="showReports ? 'ni ni-bold-up' : 'ni ni-bold-down'"></i>
        </div>
        <ul v-if="isAdmin || isNominist" v-show="showReports" class="list-unstyled ms-4">
          <sidenav-item to="/period-report" :class="getRoute() === 'period-report' ? 'active' : ''" :navText="'Nómina'">
            <template v-slot:icon>
              <i class="ni ni-money-coins text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
        <ul v-if="isAdmin || isNominist" v-show="showReports" class="list-unstyled ms-4">
          <sidenav-item to="/repse-report" :class="getRoute() === 'repse-report' ? 'active' : ''" :navText="'REPSE'">
            <template v-slot:icon>
              <i class="ni ni-square-pin text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
        <ul v-if="isAdmin" v-show="showReports" class="list-unstyled ms-4">
          <sidenav-item to="/time-records" :class="getRoute() === 'time-records' ? 'active' : ''"
            :navText="'Registros de Tiempo'">
            <template v-slot:icon>
              <i class="ni ni-watch-time text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
        <ul v-if="isAdmin" v-show="showReports" class="list-unstyled ms-4">
          <sidenav-item to="/billable-hours-report" :class="getRoute() === 'billable-hours-report' ? 'active' : ''"
            :navText="'Rentabilidad'">
            <template v-slot:icon>
              <i class="ni ni-chart-pie-35 text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
      </li>

      <!-- ADMIN - Desplegable -->
      <li class="nav-item" v-if="isAdmin">
        <div @click="showAdmin = !showAdmin" class="nav-link cursor-pointer">
          <i class="ni ni-key-25 text-warning text-sm opacity-10"></i>
          <span class="ms-2">Admin</span>
          <i class="ms-auto" :class="showAdmin ? 'ni ni-bold-up' : 'ni ni-bold-down'"></i>
        </div>
        <ul v-show="showAdmin" class="list-unstyled ms-4">
          <sidenav-item v-if="isSA" to="/users" :class="getRoute() === 'users' ? 'active' : ''" :navText="'Usuarios'">
            <template v-slot:icon>
              <i class="ni ni-single-02 text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
          <sidenav-item to="/auth-hours" :class="getRoute() === 'auth-hours' ? 'active' : ''"
            :navText="'Autorizar Horas'">
            <template v-slot:icon>
              <i class="ni ni-time-alarm text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
          <sidenav-item to="/projects" :class="getRoute() === 'projects' ? 'active' : ''" :navText="'Proyectos'">
            <template v-slot:icon>
              <i class="ni ni-app text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
      </li>

      <!-- CONFIGURACIÓN DE CUENTA - Desplegable -->
      <li class="nav-item">
        <div @click="showAccountSettings = !showAccountSettings" class="nav-link cursor-pointer">
          <i class="ni ni-settings text-warning text-sm opacity-10"></i>
          <span class="ms-2">Configuración</span>
          <i class="ms-auto" :class="showAccountSettings ? 'ni ni-bold-up' : 'ni ni-bold-down'"></i>
        </div>
        <ul v-show="showAccountSettings" class="list-unstyled ms-4">
          <sidenav-item to="/profile" :class="getRoute() === 'profile' ? 'active' : ''" :navText="'Perfil'">
            <template v-slot:icon>
              <i class="ni ni-badge text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </ul>
      </li>

    </ul>
  </div>
</template>
